<template>
  <form>
    <md-card class="md-card-login" :class="{ 'md-card-hidden': cardHidden }">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>fingerprint</md-icon>
        </div>
        <slot name="title"></slot>
      </md-card-header>
      <md-card-content>
        <slot name="description"></slot>
        <slot name="inputs"></slot>
      </md-card-content>

      <md-card-actions>
        <slot name="footer"></slot>
      </md-card-actions>
    </md-card>
  </form>
</template>

<script>
export default {
  name: "login-card",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      cardHidden: true
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    showCard: function() {
      this.cardHidden = false;
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>
<style lang="scss" scoped>
.md-card-login {
  .md-card-header {
    margin-top: 0px !important;
    text-align: left;
  }
}
</style>
